import { Box, Button } from "@mui/material";
import useApiCall from "hooks/useApiCall";
import { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { viewAllMakePayment } from "../../../api/invoiceBank";
import AddEditMakePayments from "./AddEditMakePayments";
import MakePaymentTable from "./MakePaymentTable";

const MakePayments = ({ id, assignees, profile, setReloadMain, symbol }) => {
  const [addPayment, setAddPayment] = useState(false);
  const [currPayment, setCurrPayment] = useState({});
  const [reload, setReload] = useState(false);

  const [allPayment, setAllPayment] = useState([]);
  const { data, loading, fetchData: fetchListData } = useApiCall();
  useEffect(() => {
    fetchListData(
      viewAllMakePayment,
      {
        id: profile?.id,
      },
      false
    );
  }, [reload]);

  useEffect(() => {
    if (data) {
      setAllPayment(data);
    }
  }, [data]);

  return addPayment ? (
    <AddEditMakePayments
      setReloadMain={setReloadMain}
      profile={profile}
      setAddPayment={setAddPayment}
      id={id}
      assignees={assignees}
      setReload={setReload}
      currPayment={currPayment}
    />
  ) : (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Button
          startIcon={<BiPlus />}
          variant="outlined"
          onClick={() => {
            setCurrPayment({});
            setAddPayment(true);
          }}
        >
          Add Payment
        </Button>
      </Box>
      <MakePaymentTable
        profile={profile}
        symbol={symbol}
        loading={loading}
        setReloadMain={setReloadMain}
        allPayment={allPayment}
        setReload={setReload}
        setAddPayment={setAddPayment}
        setCurrPayment={setCurrPayment}
        setAllPayment={setAllPayment}
      />
    </Box>
  );
};

export default MakePayments;
